//APP
export let APP_USER = 'app/USER'

//SETTING
export let SETTING_AUTOLOAD = 'setting/AUTOLOAD'
export let SETTING_UPDATE       = 'setting/UPDATE'